import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import BaseLayout from '../layout/BaseLayout';
import Loading from '../components/Loading';
import ProtectedRoute from '../components/ProtectedRoute';

// Sitio
const Login = lazy(() => import('../views/Login'));
const Home = lazy(() => import('../views/Home'));
const MisCursos = lazy(() => import('../views/MisCursos'));
const CursosHome = lazy(() => import('../views/Cursos'));
const ActividadesLista = lazy(() => import('../views/Cursos/actividadeslista'));
const ActividadVer = lazy(() => import('../views/Cursos/actividadver'));
const Evaluacion = lazy(() => import('../views/Evaluacion'));

// RANKING
const RankingEstudiante = lazy(() => import('../views/Ranking/RankingEstudiante'));
const RankingAdmin = lazy(() => import('../views/Ranking/RankingAdmin'));

// Sesiones
// const MisSesiones = lazy(() => import('../views/MisSesiones'));
// const EncuestaSatisfaccion = lazy(() => import('../views/EncuestaSatisfaccion'));

// Administracion
const LoginAdmin = lazy(() => import('../views/Administracion/Login'));
const Perfil = lazy(() => import('../views/Administracion/Perfil'));
const Dashboard = lazy(() => import('../views/Administracion/Dashboard'));
const AsistenteIA = lazy(() => import('../views/Administracion/AsistenteIA'));
const Reportes = lazy(() => import('../views/Administracion/Reportes'));
const Usuarios = lazy(() => import('../views/Administracion/Usuarios'));
const UsuariosCrear = lazy(() => import('../views/Administracion/Usuarios/Crear'));
const UsuariosActualizar = lazy(() => import('../views/Administracion/Usuarios/Actualizar'));
const UsuariosCargaMasiva = lazy(() => import('../views/Administracion/Usuarios/CargaMasiva'));

//Cursos
const Cursos = lazy(() => import('../views/Administracion/Cursos'));
const CursosCrear = lazy(() => import('../views/Administracion/Cursos/Crear'));
const CursosActualizar = lazy(() => import('../views/Administracion/Cursos/Actualizar'));
const CursosProgreso = lazy(() => import('../views/Administracion/Cursos/Progreso'));
const CursosProgresoCalificar = lazy(() => import('../views/Administracion/Cursos/Progreso/Calificar'));

//Actividades
const Actividades = lazy(() => import('../views/Administracion/Actividades'));
const ActividadesCrear = lazy(() => import('../views/Administracion/Actividades/Crear'));
const ActividadesActualizar = lazy(() => import('../views/Administracion/Actividades/Actualizar'));

//Áreas
const Areas = lazy(() => import('../views/Administracion/Areas'));

//Noticias (Admin) - CORREGIDO AQUÍ
const Noticias = lazy(() => import('../views/Administracion/Noticias'));
const NoticiasCrear = lazy(() => import('../views/Administracion/Noticias/Crear'));
const NoticiasActualizar = lazy(() => import('../views/Administracion/Noticias/Actualizar'));

// Noticia Detalle (Vista Pública)
const NoticiaDetalle = lazy(() => import('../views/Noticias'));
const NoticiasCatalogo = lazy(() => import('../views/Noticias/Catalogo'));

// Foros
// const SubdisciplinasView = lazy(() => import('../views/Foro/SubdisciplinasView'));
// const ForoSubdisciplina = lazy(() => import('../views/Foro/ForoSubdisciplina'));
// const ForoCrear = lazy(() => import('../views/Foro/Crear'));
// const ForoAdministrador = lazy(() => import('../views/Administracion/Foros/AdminForos'));
// const ForoDetalle = lazy(() => import('../views/Foro/ForoDetalle'));

// const Perfiles = lazy(() => import('../views/Administracion/Perfiles'));
// const PerfilesCrear = lazy(() => import('../views/Administracion/Perfiles/Crear'));
// const PerfilesActualizar = lazy(() => import('../views/Administracion/Perfiles/Actualizar'));

// const Grupos = lazy(() => import('../views/Administracion/Grupos'));
// const GruposCrear = lazy(() => import('../views/Administracion/Grupos/Crear'));
// const GruposActualizar = lazy(() => import('../views/Administracion/Grupos/Actualizar'));

const ErrorPublica = lazy(() => import('../views/ErrorPublica'));

export default function App() {
	return (
		<>
			{/* <AuthDebug /> */}
			<Suspense fallback={<Loading />}>
				<Routes>
					<Route exact path='/' element={<Login />} />
					<Route exact path='*' element={<ErrorPublica />} />
					<Route exact path='/admin/login' element={<LoginAdmin />} />
					<Route
						element={
							<ProtectedRoute>
								<BaseLayout />
							</ProtectedRoute>
						}
					>
						<Route exact path='/home' element={<Home />} />
						<Route exact path='/noticias' element={<NoticiasCatalogo />} />
						<Route exact path='/cursos' element={<MisCursos />} />
						<Route exact path='/curso/:id' element={<Navigate to={`/curso/${window.location.pathname.split("/").pop()}/actividades`} replace />} />
						<Route exact path='/curso/:id/actividades' element={<ActividadesLista />} />
						<Route exact path='/curso/:id/actividad/:indexActividad' element={<ActividadVer />} />
						<Route exact path='/evaluacion/:id' element={<Evaluacion />} />
						{/* <Route exact path='/ranking' element={<RankingEstudiante />} /> */}
						<Route exact path='/noticia/:id' element={<NoticiaDetalle />} />
						<Route exact path='/perfil' element={<Perfil />} />

						{/* <Route exact path='/mis-sesiones' element={<MisSesiones />} /> */}
						{/* <Route exact path='/encuesta-satisfaccion/:sessionId' element={<EncuestaSatisfaccion />} /> */}
						{/* <Route exact path="/experto/:id" element={<Detalle />} /> */}
						{/* <Route exact path="/foro/subdisciplinas" element={<SubdisciplinasView />} /> */}
						{/* <Route exact path="/foro/subdisciplina/:nombre" element={<ForoSubdisciplina />} /> */}
						{/* <Route exact path="/foro/crear/:nombre" element={<ForoCrear />} />
						<Route exact path="/foro/detalle/:foroId" element={<ForoDetalle />} /> */}

						{/* ADMIN */}
						{/* <Route exact path='/admin/foros' element={<ForoAdministrador />} /> */}
						<Route exact path='/admin/dashboard' element={<Dashboard />} />
						<Route exact path='/admin/asistente-ia' element={<AsistenteIA />} />
						{/* <Route exact path='/admin/reportes' element={<Reportes />} /> */}
						{/* <Route exact path='/admin/ranking' element={<RankingAdmin />} /> */}
						<Route exact path='/admin/usuarios' element={<Usuarios />} />
						<Route exact path='/admin/usuarios/crear' element={<UsuariosCrear />} />
						<Route exact path='/admin/usuarios/actualizar/:id' element={<UsuariosActualizar />} />
						<Route exact path='/admin/usuarios/carga-masiva' element={<UsuariosCargaMasiva />} />
						{/* <Route exact path='/admin/perfiles' element={<Perfiles />} /> */}
						<Route exact path='/admin/cursos' element={<Cursos />} />
						<Route exact path='/admin/cursos/crear' element={<CursosCrear />} />
						<Route exact path='/admin/cursos/actualizar/:id' element={<CursosActualizar />} />
						<Route exact path='/admin/actividades/:id?' element={<Actividades />} />
						<Route exact path='/admin/actividades/:id/crear' element={<ActividadesCrear />} />
						<Route exact path='/admin/actividades/:idCurso/actualizar/:idActividad' element={<ActividadesActualizar />} />
						<Route exact path='/admin/cursos/progreso/:id' element={<CursosProgreso />} />
						<Route exact path='/admin/cursos/progreso/:id/calificar/:idActividad/:idUsuario' element={<CursosProgresoCalificar />} />
						{/* <Route exact path='/admin/areas' element={<Areas />} /> */}
						<Route exact path='/admin/noticias' element={<Noticias />} />
						<Route exact path='/admin/noticias/crear' element={<NoticiasCrear />} />
						<Route exact path='/admin/noticias/actualizar/:id' element={<NoticiasActualizar />} />
						{/* <Route exact path='/admin/usuarios/grupos' element={<Grupos />} /> */}
						{/* <Route exact path='/admin/usuarios/grupos/crear' element={<GruposCrear />} /> */}
						{/* <Route exact path='/admin/usuarios/grupos/actualizar/:id' element={<GruposActualizar />} /> */}
					</Route>
				</Routes>
			</Suspense>
		</>
	);
}
